import React, { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { AppConstant } from "../../../../../../Assests/AppConstant";
import CustomButtonSS from "../../../../../Common/CustomButton/CustomButtonSS";
import CustomFieldWithTtileSS from "../../../../../Common/CustomField/CustomFieldWithTtileSS";
import { getWhMetaDataReducerSlice } from "../../../../../../../redux/reducers/reducerSlices/WhMetaDataReducerSlice";
import { useSelector } from "react-redux";
import _ from "lodash";
import { fetchDockListCommonFunc } from "../../../../../LandingPage/SmartScheduler/WarehouseMetaData/Forms/DocksMeta/Common/FetchDockList";
import { sagaActions } from "../../../../../../../sagas/sagaActions";
import { changeFormatWithoutTz } from "../../../../../../Assests/Utility";

const AddCapacityMangementSlots = ({
  actionHandler,
  initateLoading,
  editData,
  whObj,
}) => {
  const dispatch = useDispatch();
  const [IDDock, setIDDock] = useState(null);
  const [selectedDock, setSelectedDock] = useState(null);

  const [inputs, setInputs] = useState([
    {
      ID:"",
      StartTime: "",
      EndTime: "",
      CPH: "",
      PPH: "",
      TPH: "",
    },
  ]);
  const whMetaData = useSelector(getWhMetaDataReducerSlice);
  const { dockTypeList, whMetaDocksList } = whMetaData;
  const [dockListType, setDockListType] = useState(null);
  //validation code
  let [errors, setErrors] = useState([
    {
      StartTime: [],
      EndTime: [],
      CPH: [],
      PPH: [],
      TPH: [],
    },
  ]);

  let [dirty, setDirty] = useState([
    {
      StartTime: false,
      EndTime: false,
      CPH: false,
      PPH: false,
      TPH: false,
    },
  ]);
  

  let handleChange = (data, name,singData) => {
    // const { name, value } = e.target;
    singData[name] = data;
    setInputs([...inputs]);
  };

  useEffect(() => {
    if (whObj) {
    const fetchDockList = () => {
      const { apiParams, operationObj } = fetchDockListCommonFunc(whObj);
      dispatch({
        type: sagaActions.WAREHOUSE_META_DOCK_LIST_ACTION,
        payload: apiParams,
        operationObj: operationObj,
      });
    };
    fetchDockList();
  }
  }, [whObj]);

  useEffect(() => {
    if (IDDock) {
      let dockData = whMetaDocksList.filter((el) => el.ID === IDDock);
      if (dockData.length) {
        setSelectedDock(dockData[0]);
      }
    }
  }, [IDDock]);

  useEffect(() => {
    if (whMetaDocksList.length) {
      let nArray = [];
      whMetaDocksList.forEach((el, i) => {
        let objDockList = {};
        objDockList.dockName = el.Name;
        objDockList.id = el.ID;
        nArray.push(objDockList);
      });
      setDockListType(nArray);
    } else {
      setDockListType([]);
    }
  }, [whMetaDocksList]);

  useEffect(() => {
    if (editData && Object.keys(editData).length) {
    let newArr = [];
    if (editData && editData.IDDock) {
      setIDDock(editData.IDDock);
    }
    if (
      editData &&
        editData.slots &&
      editData.slots.length < 1
    ) {
      newArr.push({ StartTime: "", EndTime: "", CPH: "", PPH: "", TPH: "" });
    } else {
      editData.slots?.forEach((el, i) => {
        newArr.push({
          ID: el.ID || "",
          StartTime: changeFormatWithoutTz(el.StartTime, "HH:mm"),
          EndTime: changeFormatWithoutTz(el.EndTime, "HH:mm"),
          CPH: el.CPH || "",
          PPH: el.PPH || "",
          TPH: el.TPH || "",
          disabled: false,
        });
      });
    }
    setInputs([...newArr]);
    validationDynamic(newArr.length);
  }
  }, [editData]);

  
  let validate = () => {
    let valid = true;
    for (let i = 0; i < inputs.length; i++) {
      Object.keys(errors[i]).forEach((con) => {
        errors[i][con] = [];
        if (
          selectedDock.CapacityModeling === "Productivity" &&
          (con === "PPH" || con === "CPH")
        ) {
          if (!inputs[i][con]) {
            errors[i][con].push("This field is required");
            valid = false;
          }
        } else if (selectedDock.CapacityModeling === "TPH" && con === "TPH") {
          if (!inputs[i][con]) {
            errors[i][con].push("This field is required");
            valid = false;
          }
          
        }
        if (con === "StartTime" || con === "EndTime") {
          if (!inputs[i][con]) {
            errors[i][con].push("This field is required");
            valid = false;
          }else if (inputs[i][con]) {
            for (let j = 0; j < inputs.length; j++) {
              if (i !== j) {
                 
              if (
                isTimeInRange(inputs[i][con], inputs[j]["StartTime"], inputs[j]["EndTime"])
               
              ) {
                
                errors[i][con].push("Time overlaps with another slot");
                valid = false;
              }
              }
            }
          }
        }
      });
    }

    setErrors([...errors]);
    return valid;
  };
  let validationDynamic = (length) => {
    let dirtyData = [];
    let errorsData = [];
    for (let i = 0; i < length; i++) {
      dirtyData[i] = {
        StartTime: false,
        EndTime: false,
        CPH: false,
        PPH: false,
        TPH: false,
      };
      errorsData[i] = {
        StartTime: [],
        EndTime: [],
        CPH: [],
        PPH: [],
        TPH: [],
      };
    }
    setDirty([...dirtyData]);
    setErrors([...errorsData]);
  };
  let blurChange = (e, index) => {
    let dirtyData = dirty[index];
    dirtyData[e.target.name] = true;
    setDirty([...dirty]);
    validate();
  };



  const onSubmit = async () => {
    for (let i = 0; i < inputs.length; i++) {
      Object.keys(dirty[i]).forEach((control) => {
        dirty[i][control] = true;
      });
    }
    setDirty([...dirty]);
    if (validate()) {
      if (Object.keys(editData).length) {
        actionHandler(inputs, IDDock, "EDIT");
      }else{
      actionHandler(inputs,IDDock, "ADD");
      }
    }
  };

  const addMoreField = () => {
    setInputs([
      ...inputs,
      {
        StartTime: "",
        EndTime: "",
        CPH: "",
        PPH: "",
        TPH: "",
      },
    ]);
    validationDynamic(inputs.length + 1);
  };

  const removeField = (index) => {
    let indexData = [...inputs];
    const removePo = inputs[index];
    indexData.splice(index, 1);
    setInputs(indexData);
    validationDynamic(inputs.length - 1);
    if (editData && Object.keys(editData).length) {
    actionHandler(removePo, IDDock, "REMOVE");
      
    }
  };

  const getDockList = () => {
    return (
      dockListType &&
      _.isArray(dockListType) &&
      dockListType?.map((ele, index) => {
        return (
          <option key={ele.id} value={ele.id}>
            {ele.dockName}
          </option>
        );
      })
    );
  };

  const isTimeInRange = (selectedTime, StartTime, EndTime) => {
    const toMinutes = (time) => {
      const [h, m] = time.split(":").map(Number);
      return h * 60 + m;
    };

    const selected = toMinutes(selectedTime);
    const start = toMinutes(StartTime);
    const end = toMinutes(EndTime);

    return selected > start && selected < end;
  };


  return (
    <>
      <div
        className=" d-flex flex-column justify-content-center"
        data-testid="AddMorePOPopupSS"
      >
        <div className="">
          <div className="w-25 text-start">
            <CustomFieldWithTtileSS
              type={"select"}
              disabledField={Object.keys(editData).length ? true : false}
              name={"IDDock"}
              value={IDDock ? IDDock : ""}
              handleErrors={() => {}}
              title={"Dock Type"}
              required={true}
              onChange={(data, name) => {
                setIDDock(data);
              }}
              listData={getDockList}
            />
          </div>
        
          {IDDock && (
            <>
              <div
                className="d-flex justify-content-between align-items-center gap-3"
                style={{ width: "95%" }}
              >
                <div className="w-100 text-start">
                  {" "}
                  {`Start Time`}&nbsp;{<span className="color-red">*</span>}
                </div>
                <div className="w-100 text-start">
                  {`End Time`}&nbsp;{<span className="color-red">*</span>}
                </div>

                {selectedDock &&
                  selectedDock?.CapacityModeling === "Productivity" && (
                    <div className="w-100 text-start">
                      {`PPH`}&nbsp;{<span className="color-red">*</span>}
                    </div>
                  )}
                {selectedDock &&
                  selectedDock?.CapacityModeling === "Productivity" && (
                    <div className="w-100 text-start">
                      {`CPH`}&nbsp;{<span className="color-red">*</span>}
                    </div>
                  )}
                {selectedDock && selectedDock?.CapacityModeling === "TPH" && (
                  <div className="w-100 text-start">
                    {`TPH`}&nbsp;{<span className="color-red">*</span>}
                  </div>
                )}
              </div>
              {inputs.map((singData, index) => (
                <>
                  <div className="d-flex justify-content-between align-items-center gap-2">
                    <div className="w-100">
                      <CustomFieldWithTtileSS
                        className={"w-100"}
                        type={"custom-time-selector"}
                        showError={
                          dirty["StartTime"] && errors["StartTime"][0]
                            ? errors["StartTime"]
                            : ""
                        }
                        name={"StartTime"}
                        value={singData.StartTime ? singData.StartTime : ""}
                        handleErrors={(e) => blurChange(e, index)}
                        required={true}
                        maxTime={
                          selectedDock && selectedDock.EndTime
                            ? changeFormatWithoutTz(
                                selectedDock.EndTime,
                                "HH:mm"
                              )
                            : ""
                        }
                        minTime={
                          selectedDock && selectedDock.StartTime
                            ? changeFormatWithoutTz(
                                selectedDock.StartTime,
                                "HH:mm"
                              )
                            : ""
                        }
                        onChange={(data, name) =>
                          handleChange(data, name, singData)
                        }
                        hideElement={{ isHidden: false }}
                      />

                      {errors.length > 0 &&
                      dirty.length > 0 &&
                      dirty[index]["StartTime"] &&
                      errors[index]["StartTime"][0] ? (
                        <span
                          className="errorMessage"
                          data-testid={AppConstant.dataTestId.validationError}
                        >
                          {errors[index]["StartTime"][0]}
                        </span>
                      ) : (
                        ""
                      )}
                    </div>
                    <div className="w-100">
                      <CustomFieldWithTtileSS
                        className={"w-100"}
                        type={"custom-time-selector"}
                        showError={
                          dirty["EndTime"] && errors["EndTime"][0]
                            ? errors["EndTime"]
                            : ""
                        }
                        name={"EndTime"}
                        value={singData.EndTime ? singData.EndTime : ""}
                        handleErrors={(e) => blurChange(e, index)}
                        required={true}
                        maxTime={
                          selectedDock && selectedDock.EndTime
                            ? changeFormatWithoutTz(
                                selectedDock.EndTime,
                                "HH:mm"
                              )
                            : ""
                        }
                        minTime={
                          selectedDock && selectedDock.StartTime
                            ? changeFormatWithoutTz(
                                selectedDock.StartTime,
                                "HH:mm"
                              )
                            : ""
                        }
                        onChange={(data, name) =>
                          handleChange(data, name, singData)
                        }
                        hideElement={{ isHidden: false }}
                      />
                      {errors.length > 0 &&
                      dirty.length > 0 &&
                      dirty[index]["EndTime"] &&
                      errors[index]["EndTime"][0] ? (
                        <span
                          className="errorMessage"
                          data-testid={AppConstant.dataTestId.validationError}
                        >
                          {errors[index]["EndTime"][0]}
                        </span>
                      ) : (
                        ""
                      )}
                    </div>
                    {selectedDock &&
                      selectedDock?.CapacityModeling === "Productivity" && (
                        <div className="w-100">
                          <input
                            data-testid={AppConstant.dataTestId.customInput}
                            type={"number"}
                            value={singData.PPH}
                            name="PPH"
                            style={{ width: "100%" }}
                            className={
                              errors.length > 0 &&
                              dirty.length > 0 &&
                              dirty[index]["PPH"] &&
                              errors[index]["PPH"][0]
                                ? "customTextInput customTextInputError w-100"
                                : "customTextInput w-100"
                            }
                            onBlur={(e) => blurChange(e, index)}
                            onInput={(e) =>
                              handleChange(
                                e.target.value,
                                e.target.name,
                                singData
                              )
                            }
                            disabled={false}
                          />
                          {errors.length > 0 &&
                          dirty.length > 0 &&
                          dirty[index]["PPH"] &&
                          errors[index]["PPH"][0] ? (
                            <span
                              className="errorMessage"
                              data-testid={
                                AppConstant.dataTestId.validationError
                              }
                            >
                              {errors[index]["PPH"][0]}
                            </span>
                          ) : (
                            ""
                          )}
                        </div>
                      )}
                    {selectedDock &&
                      selectedDock?.CapacityModeling === "Productivity" && (
                        <div className="w-100">
                          <input
                            data-testid={AppConstant.dataTestId.customInput}
                            type={"number"}
                            value={singData.CPH}
                            name="CPH"
                            style={{ width: "100%" }}
                            className={
                              errors.length > 0 &&
                              dirty.length > 0 &&
                              dirty[index]["CPH"] &&
                              errors[index]["CPH"][0]
                                ? "customTextInput customTextInputError w-100"
                                : "customTextInput w-100"
                            }
                            onBlur={(e) => blurChange(e, index)}
                            onInput={(e) =>
                              handleChange(
                                e.target.value,
                                e.target.name,
                                singData
                              )
                            }
                            disabled={false}
                          />
                          {errors.length > 0 &&
                          dirty.length > 0 &&
                          dirty[index]["CPH"] &&
                          errors[index]["CPH"][0] ? (
                            <span
                              className="errorMessage"
                              data-testid={
                                AppConstant.dataTestId.validationError
                              }
                            >
                              {errors[index]["CPH"][0]}
                            </span>
                          ) : (
                            ""
                          )}
                        </div>
                      )}
                    {selectedDock &&
                      selectedDock?.CapacityModeling === "TPH" && (
                        <div className="w-100">
                          <input
                            data-testid={AppConstant.dataTestId.customInput}
                            type={"number"}
                            value={singData.TPH}
                            name="TPH"
                            style={{ width: "100%" }}
                            className={
                              errors.length > 0 &&
                              dirty.length > 0 &&
                              dirty[index]["TPH"] &&
                              errors[index]["TPH"][0]
                                ? "customTextInput customTextInputError w-100"
                                : "customTextInput w-100"
                            }
                            onBlur={(e) => blurChange(e, index)}
                            onInput={(e) =>
                              handleChange(
                                e.target.value,
                                e.target.name,
                                singData
                              )
                            }
                            disabled={false}
                          />
                          {errors.length > 0 &&
                          dirty.length > 0 &&
                          dirty[index]["TPH"] &&
                          errors[index]["TPH"][0] ? (
                            <span
                              className="errorMessage"
                              data-testid={
                                AppConstant.dataTestId.validationError
                              }
                            >
                              {errors[index]["TPH"][0]}
                            </span>
                          ) : (
                            ""
                          )}
                        </div>
                      )}
                    <span className=" px-3 mt-2 d-flex justify-content-center align-items-center">
                      <i
                        className="fa fa-times fa-lg"
                        aria-hidden="true"
                        data-testid={AppConstant.dataTestId.closeBtn}
                        style={{ cursor: "pointer" }}
                        onClick={() => removeField(index)}
                      ></i>
                    </span>
                  </div>
                </>
              ))}
            </>
          )}
        </div>
      </div>

      <div className="d-flex  justify-content-start mt-4">
        <div className="m-0 p-0">
          <CustomButtonSS
            isLoading={false}
            title={"+ Add More Slots"}
            className={"btn-popup-ss-btn-secondary"}
            onClick={addMoreField}
          />
        </div>
        <div className="m-0 p-0">
          <CustomButtonSS
            isLoading={initateLoading}
            title={"Save"}
            className={"btn-popup-ss-btn-1 ms-3"}
            onClick={onSubmit}
          />
        </div>
      </div>
    </>
  );
};
export default AddCapacityMangementSlots;
